import { Loading } from "components/Loading/Loading";

export default Loading;
